import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { MetadataLoadingStage, UserContextService } from 'src/app/core/services/user-context.service';
import { buildRoutePrefix } from 'src/app/core/util';

@Component({
  selector: 'app-waiting-page',
  templateUrl: './waiting-page.component.html',
  styleUrl: './waiting-page.component.scss'
})
export class WaitingPageComponent implements OnInit {
  progress: number = 0;
  totalTime: number = 75 * 60 * 1000; // Mocked time
  remainingTime: number = this.totalTime; // Mocked time

  message$ = new BehaviorSubject<string>('Downloading and synchronizing data...');
  progressText = ''

  constructor(private userContextService: UserContextService, private router: Router) {
    userContextService.MetadataLoadingStage$.subscribe(stage => {
      if (stage >= MetadataLoadingStage.InstanceConnectorsLoaded) {
        this.message$.next('Finalizing. Connecting to chat server...');
        this.progressText = 'Almost there';
        this.remainingTime = (this.totalTime) / 100;
      } else if (stage >= MetadataLoadingStage.InstanceMetadataLoaded) {
        this.message$.next('Syncing and integrating data...');
        this.progressText = 'Uploading connectors'
        this.remainingTime = (this.totalTime * 80) / 100;
      } else if (stage < MetadataLoadingStage.InstanceMetadataLoaded) {
        this.message$.next('Deploying instance...');
        this.progressText = 'Deploying backend'
      }
      this.calculateProgress();
    });
  }

  ngOnInit(): void {
    // Trigger the deployment search process
    this.userContextService.TriggerDeploymentSearch();

    this.userContextService.MetadataLoadingStage$.subscribe(stage => {
      if (stage >= MetadataLoadingStage.InstanceConnectorsLoaded) {
        const prefix = buildRoutePrefix(this.userContextService.CurrentInstance.ID);
        this.router.navigate([prefix, 'chat']); // Navigate to chat
      }
    });
    this.simulateProgress();
  }

  simulateProgress() {
    const refreshInterval = 10000; // 10 seconds
    const interval = setInterval(() => {
      if (this.remainingTime > 0) {
        this.remainingTime = this.remainingTime - refreshInterval;
        this.calculateProgress();
      } else {
        clearInterval(interval);
      }
    }, refreshInterval); // Simulates progress every 10 seconds
  }

  calculateProgress() {
    this.progress = (1 - (this.remainingTime / this.totalTime)) * 100;
  }

  calculateTimeLeftInMins() {
    return Math.floor(this.remainingTime / 60000);
  }
}
